export default __webpack_public_path__ + "static/media/f002.4d9bdaf1.png";